import React from "react"
import PropTypes from "prop-types"
import { Link, graphql } from "gatsby"
import "bootstrap/dist/css/bootstrap.css"
import "../pages/index.css"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Sidebar from "../components/sidebar/Sidebar"
import TechTag from "../components/tags/TechTag"

const Tag = ({ pageContext, data }) => {
    const posts = data.allMarkdownRemark.edges
    const labels = data.site.siteMetadata.labels
    console.log(pageContext.tag)
    const { tag } = pageContext
    const { totalCount } = data.allMarkdownRemark
    const tagHeaderTag = `${tag}`
    const tagHeader = ` 태그로 찾은 ${totalCount} 개의 포스트에요. `

    const getTechTags = (tags) => {
        const techTags = []
        tags.forEach((tag, i) => {
            labels.forEach((label) => {
                if (tag === label.tag) {
                    techTags.push(<TechTag key={i} tag={label.tag} tech={label.tech} name={label.name} size={label.size} color={label.color} />)
                }
            })
        })
        return techTags
    }

    return (
        <Layout>
            <SEO title="SearchResult" keywords={[`gatsby`, `javascript`, `react`, `web development`, `node.js`, `graphql`]} />
            <div className="index-main">
                <div className="sidebar px-4 py-2">
                    <Sidebar />
                </div>

                <div className="post-list-main mt-5">
                    <h3 className="heading text-dark tag-header mb-0">
                    <span className="headerTag text-uppercase">{tagHeaderTag}</span>
                    {tagHeader}
                    </h3>
                    {posts.map((post) => {
                    const tags = post.node.frontmatter.tags
                    return (
                        <Link to={post.node.fields.slug} className="text-dark container post-card">
                            <div key={post.node.id} className="py-3 bg-light border shadow-lg">
                            <h2 className="title mb-2 text-dark">{post.node.frontmatter.title}</h2>
                            <small className="d-block text-primary mb-3"><i>{post.node.frontmatter.date}에 게시됨</i></small>
                            <div className="m-1">
                            <p className="mt-3 d-inline">{post.node.excerpt}</p>
                            </div>
                            <div className="d-block mt-3">
                            {getTechTags(tags)}
                            </div>
                            </div>
                            </Link>)})}
                </div>
            </div>
        </Layout>
    )
}

Tag.propTypes = {
    pageContext: PropTypes.shape({
        tag: PropTypes.string.isRequired,
    }),
    data: PropTypes.shape({
        allMarkdownRemark: PropTypes.shape({
            totalCount: PropTypes.number.isRequired,
            edges: PropTypes.arrayOf(
                PropTypes.shape({
                    node: PropTypes.shape({
                        frontmatter: PropTypes.shape({
                            title: PropTypes.string.isRequired,
                        }),
                    }),
                }).isRequired
            ),
        }),
    }),
}

export const pageQuery = graphql`
  query($tag: String) {
    site {
        siteMetadata {
            title 
            author
            labels {
                tag
                tech 
                name 
                size 
                color
            } 
        }
    } 
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
         node {
            excerpt(pruneLength: 200)
            html
            id
            frontmatter {
                title
                date(formatString: "MMMM, YYYY")
                tags
            }
             fields {
                slug
            }
        }
      }
    }
  }
`

export default Tag